import React from 'react';

const VowsDisplay = ({ data, onNewVows }) => {
  if (!data) {
    return (
      <div className="glass-card text-center">
        <h2>No vows to display</h2>
        <button className="btn btn-primary mt-3" onClick={onNewVows}>
          Create New Vows
        </button>
      </div>
    );
  }

  const handlePrint = () => {
    window.print();
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(data.vowsText);
    alert('Vows copied to clipboard!');
  };

  return (
    <div className="glass-card">
      <div className="vow-header">
        <h2 className="vow-names" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
          {data.yourName}'s Vows to {data.partnerName}
        </h2>
        {data.weddingDate && (
          <p className="vow-date">
            {new Date(data.weddingDate).toLocaleDateString('en-US', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>
        )}
      </div>

      <div className="vow-content">
        {data.vowsText.split('\n\n').map((paragraph, index) => (
          <p key={index} style={{ fontFamily: "'Lora', serif", lineHeight: '1.8' }}>
            {paragraph}
          </p>
        ))}
      </div>

      <div className="d-flex flex-column flex-md-row gap-3 justify-content-center mt-4">
        <button 
          className="btn btn-primary"
          onClick={handlePrint}
        >
          <i className="bi bi-printer me-2"></i>
          Print Vows
        </button>
        <button 
          className="btn btn-secondary"
          onClick={handleCopy}
        >
          <i className="bi bi-clipboard me-2"></i>
          Copy to Clipboard
        </button>
        <button 
          className="btn btn-secondary"
          onClick={onNewVows}
        >
          <i className="bi bi-plus-circle me-2"></i>
          Create New Vows
        </button>
      </div>

      <style>{`
        @media print {
          .commercial-navbar, .site-footer, .btn, .page-decoration {
            display: none !important;
          }
          .glass-card {
            background: white !important;
            box-shadow: none !important;
            border: none !important;
          }
          body {
            background: white !important;
          }
          body::before {
            display: none !important;
          }
        }
      `}</style>
    </div>
  );
};

export default VowsDisplay;


